import React from 'react'

const GoogleWorkspaceForEducationProductDetail = () => {
  return (
    <div>
      Hii !!!!
    </div>
  )
}

export default GoogleWorkspaceForEducationProductDetail
